export const defaultConnections = ['AemEnvironment', 'TranslationManager', 'Tracking'];
export const defaultPackages = ['ComponentRegistry'];
export const defaultStarters = ['SeamlessStore', 'SeamlessLogger'];
